<template>
  <div class="wrap">

    <div class="page-common">
      <div class="idx-Main idx" v-if="navIndex == 1">
        <div class="flo">
          <div class="t-ae"></div>
          <div class="b-left"></div>
        </div>
        <div class="t-back" @click="handleBack()"></div>
        <div class="share-icon testenter">
          <div class="s-logo"></div>
          <div class="s-icon-2">
            <div class="icon-size ds">
              <img src="../assets/img/ds.png" alt="" srcset="" @click="handleDs('ds')">
            </div>
            <div class="icon-size youtube" @click="handleYoutube('yt')">
              <img src="../assets/img/youtube.png" alt="" srcset="">
            </div>

          </div>
          <div class="s-icon-3">
            <div class="icon-size twi" @click="handleTwi('twi')">
              <img src="../assets/img/twi.png" alt="" srcset="">
            </div>
            <div class="icon-size Instagram" @click="handleInstagram('instagram')">
              <img src="../assets/img/Instagram.png" alt="" srcset="">
            </div>
            <div class="icon-size tiktok" @click="handleTiktok('tiktok')">
              <img src="../assets/img/tiktok.png" alt="" srcset="">
            </div>
          </div>
        </div>
        <!-- 底栏 -->
        <div class="t-nav-bottom">
          <div class="nav-cnt">
            <img src="../assets/img/button-ios.png" alt="" srcset="" @click="handleIOS('ios')">
            <img src="../assets/img/button-google.png" alt="" srcset="" @click="handleGG('gg')">
            <img src="../assets/img/button-windows.png" alt="" srcset="" @click="handleWindows()">
            <img src="../assets/img/button-stm.png" alt="" srcset="" @click="handleGG('stm')">
          </div>
        </div>

        <!-- 页面 -->
        <home @handleShowVideo="videoFlag = true" />
        <progressPage :isPreviewNumber="infoPreviewNumber" ref="silder2" />
        <cha />
        <sys />
        <worldView />
        <story />
        <copyright />
      </div>
      <!-- <div class="idx-progress idx" v-if="navIndex == 2">
        <progressPage :isPreviewNumber="infoPreviewNumber" ref="silder2" />
        <div class="footer"></div>
      </div> -->
      <div class="idx-role idx" v-if="navIndex == 3">
        <rolepage @handleRoleVideo="handleRoleVideo" />
        <slPage />
        <!-- 底部 -->
        <div class="footer"></div>
      </div>
      <div class="idx-sys idx" v-if="navIndex == 4">
        <newSys />

      </div>
      <div class="idx-world idx" v-if="navIndex == 5">
        <worldView />
        <story />
        <!-- 底部 -->
        <div class="footer"></div>
      </div>
      <div class="idx-news idx" v-if="navIndex == 6">
        <news />
        <!-- 底部 -->
        <div class="footer"></div>
      </div>
    </div>

    <!-- 菜单 -->
    <!-- <headerNav @handleNavIndex="handleNavIndex" @handleOpenVoice="open_voice" @handleCloseVoice="close_voice" /> -->
    <headerNav @handleNavIndex="handleNavIndex" />
   
    <!--首页视频弹出框 -->
    <div v-if="videoFlag" class="model position-fixed" @click="videoFlag = false">
      <div class="v-txt">
        <iframe width="100%" height="100%" src="https://www.youtube.com/embed/aJTS0c8ZVxw?si=hbr9dRIU9ZGFTFoX"
          title="YouTube video player" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
    </div>
    <!-- 角色视频弹出框 -->
    <div v-if="roleVideoFlag" class="model position-fixed" @click="roleVideoFlag = false">
      <div class="v-txt">
        <video class="home_video__jx2_E" loop autoplay playsinline="">
          <source :src="roleVideoUrl" type="video/mp4">
        </video>
      </div>
    </div>
  </div>
</template>

<script>
import home from "./publicComponents/home";
import progressPage from "./publicComponents/progressPage";
import cha from "./publicComponents/cha";
import sys from "./publicComponents/sys";
import newSys from "./publicComponents/newSys";
import worldView from "./publicComponents/worldView";
import story from "./publicComponents/story";
import copyright from "./publicComponents/copyright";
import rolepage from "./publicComponents/rolepage";
import news from "./publicComponents/news";
import headerNav from "./publicComponents/headerNav";
import slPage from "./publicComponents/slPage";




export default {
  name: "Home",
  components: {
    home,
    progressPage,
    cha,
    sys,
    worldView,
    story,
    copyright,
    rolepage,
    newSys,
    news,
    headerNav,
    slPage
  },
  data() {
    return {
    
      navIndex: 1,
      videoFlag: false,
      roleVideoFlag: false,
      roleVideoUrl: "https://resource-mp4.ujoygames.com/ashechoes/cha-1.mp4",
      e: "",
      infoPreviewNumber: 0
    };
  },
  created() {
    this.initData()

    // 获取上次点击的区域 
    this.navIndex = 1
    let test = this.$route.query.view >= 1 ? this.$route.query.view : this.$route.query.view
    this.navIndex = test || 1


  },
  updated() { },
  mounted() {
    window.addEventListener("scroll", this.handleScrollTop, true);
  },
  watch: {},
  computed: {},
  methods: {
    handleWindows() {
      window.open(`https://ashechoes-cdn.ujoygames.jp/jp/file/_inst/b4665b3a92f29a95ab5859708d124d58/seed_setup_ja_pro_1.5.8.exe`, '_blank');
    },
    handleRoleVideo(val) {
      this.roleVideoFlag = true
      this.roleVideoUrl = `https://resource-mp4.ujoygames.com/ashechoes/cha-${val}.mp4`
    },
    handleNavIndex(val) {
      this.navIndex = val
      this.$router.push({
        query: { ...this.$route.query, view: val }
      })

      if (this.navIndex == 1 || this.navIndex == 2) {
        this.initData()
      }

    },
    handleIOS(val) {
      this.common.goShare(val);

    },
    handleGG(val) {
      this.common.goShare(val);

    },
    handleDs(val) {
      this.common.goShare(val);
    },
    handleYoutube(val) {
      this.common.goShare(val);
    },
    handleTwi(val) {
      this.common.goShare(val);
    },
    handleInstagram(val) {
      this.common.goShare(val);
    },
    handleTiktok(val) {
      this.common.goShare(val);
    },
    handleBack() {
      this.e.scrollTop = 0
    },
    //滚动事件触发时候会传e 里面有滚动的数据
    handleScrollTop(e) {
      this.e = e.target
    },
    // info 接口获取数据
    initData() {
      const reqTime = Math.floor(new Date().getTime() / 1000);
      let url = window.location.search
      let preview = 'unknow';

      // let previewParam = url.indexOf("preview") >= 0 ? this.common.getUrlParam("preview").slice(0, -2) : this.common.getUrlParam("preview")
      let previewParam = url.indexOf("preview") >= 0 ? this.common.getUrlParam("preview") : this.common.getUrlParam("preview")
      preview = previewParam || 'unknow';


      this.$axios({
        method: "post",
        url: "ashechoes/info",
        data: {
          //get这里应为params
          //请求参数
          signature: this.common.makeSignature({}, reqTime),
          reqTime: reqTime,
          // preview: this.common.getUrlParam("preview") || 0, // 测试数据
          preview: preview,
        },
        //withCredentials:true, //局部携带cookie
        headers: {}, //如果需要添加请求头可在这写
      })
        .then((res) => {
          if (res.data.code === 0) {
            this.$refs.silder2.preview = res.data.data.register;
            this.infoPreviewNumber = res.data.data.register

          }
        })
        .catch((err) => {
          //请求失败就会捕获报错信息
          //err.response可拿到服务器返回的报错数据
        });

    },
    // 新闻列表数据

  },
  destroyed() {
    //本页面销毁时候，把滚动事件取消掉
    window.removeEventListener("scroll", this.handleScrollTop, true);
  },
};
</script>
<style lang="scss">
.wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  box-sizing: border-box;
  overflow-y: scroll;
  overflow-x: hidden;
  background: url('../assets/img/bg.jpg');
  position: relative;
  scroll-behavior: smooth;
  background-size: cover;




  .page-common {

    width: 100%;
    height: 100%;

    .idx {
      width: 100%;
      height: 100%;
    }

    .idx-Main {

      .flo {

        position: fixed;
        width: 100%;
        height: 100%;


        .t-ae {
          background: url('../assets/img/t-ae.png') no-repeat;
          width: 181px;
          height: 49px;
          position: absolute;
          top: 34px;
          left: 34px;
          background-size: 100% 100%;
        }



        .b-left {
          background: url('../assets/img/b-left.png') no-repeat;
          width: 116px;
          height: 75px;
          position: absolute;
          bottom: 34px;
          left: 34px;
          background-size: 100% 100%;
        }



      }

      .t-nav-bottom {
        background: url('../assets/img/ae-web.png') no-repeat;
        width: 988px;
        height: 107px;
        position: fixed;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 0);
        background-size: 100% 100%;

        z-index: 1;

        .nav-cnt {
          width: 100%;
          height: 100%;
          position: relative;
          // right: 50px;
          display: flex;
          align-items: center;
          gap: 6px;
          justify-content: center;

          img {
            width: 227px;
            height: 66px;
            display: block;
            cursor: pointer;
          }
        }
      }

      .t-back {
        background: url('../assets/img/t-back.png') no-repeat;
        width: 181px;
        height: 66px;
        position: fixed;
        top: 34px;
        right: 34px;
        background-size: 100% 100%;
        cursor: pointer;
        z-index: 1;
      }

      .share-icon {
        position: fixed;
        bottom: 34px;
        right: 34px;
        z-index: 1;
        display: flex;
        align-items: end;
        gap: 16px;

        img {
          width: 100%;
          height: 100%;
        }

        .s-logo {
          background: url('../assets/img/logo.png') no-repeat;
          width: 166px;
          height: 54px;
          background-size: 100% 100%;
        }

        .icon-size {
          width: 36px;
          height: 36px;
          margin-bottom: 4px;
          cursor: pointer;
        }

      }

    }
  }


  &::-webkit-scrollbar {
    width: 2px;
    height: 2px !important;

  }

  &::-webkit-scrollbar-thumb {
    background: transparent;

  }
}

.footer {
  width: 100%;
  height: 120px;
  background: url("../assets/img/down-cpr.png") no-repeat top;
  background-size: 100% 100%;

}
</style>


// WEBPACK FOOTER //
// src/components/MainIndex.vue